import { Button, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useSnackbar } from 'notistack';

import useAuth from 'hooks/useAuth';
import useCurrentUser from 'hooks/useCurrentUser';
import { useAppDispatch } from 'store';
import { atualizarDisponibilidadeUsuario } from 'store/reducers/usuarios';

function AlertaIndisponibilidade() {
  const currentUser = useCurrentUser();
  const { setCurrentUser } = useAuth();
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleAtualizarDisponibilidadeUsuario = () => {
    dispatch(atualizarDisponibilidadeUsuario({ disponivel: true }))
      .unwrap()
      .then(response => {
        enqueueSnackbar(response.message);

        if (currentUser) {
          setCurrentUser({ ...currentUser, disponivel: true });
        }
      });
  };

  return (
    <Alert
      icon={false}
      severity="warning"
      action={
        <Button
          color="default"
          style={{ minWidth: 120 }}
          size="small"
          onClick={handleAtualizarDisponibilidadeUsuario}
        >
          Ficar disponível
        </Button>
      }
    >
      <Typography variant="body2">
        Você está <b>indisponível</b> para a distribuição automática da fila.
      </Typography>
    </Alert>
  );
}

export default AlertaIndisponibilidade;
